import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import api from './api'
import '../../../workspace/quick-create/node_modules/normalize.css/normalize.css'
import router from './router'
import store from './store'

createApp(App).use(api).use(Antd).use(store).use(router).mount('#app')
